<template>
  <div>
    <Accordion
      v-if="!fn_IS_MOBILE()"
      :categories="categories"
      :loading="loading"
    />
    <MobileAccordion
      v-else
      :daysView="daysView"
      :categories="categories"
      :loading="loading"
    />
  </div>
</template>
<script>
import Accordion from '@/components/layout/accordion'
import MobileAccordion from '@/components/layout/mobile/mobileAccordion'

export default {
  props: ['appointments', 'loading', 'selectedOffice', 'daysView'],
  components: {
    Accordion,
    MobileAccordion
  },
  data () {
    return {
      showMenu: false,
      categories: [
        {
          label: 'Atendimento',
          total: 0,
          icon: 'agenda',
          data: {}
        },
        {
          label: 'Exame',
          icon: 'fileMedical',
          total: 0,
          data: []
        },
        {
          label: 'Cancelamento',
          icon: 'userTimes',
          total: 0,
          data: []
        }
      ],
      medicalExams: []
    }
  },
  computed: {
    getAppointments () {
      return this.appointments
    }
  },
  mounted () {
    this.buildData()
  },
  watch: {
    appointments (next, prev) {
      this.buildData()
    }
  },
  methods: {
    buildData () {
      for (let cat of this.categories) {
        cat.total = 0
        cat.data = []
      }
      this.categories[0].data = {}
      for (let appointment of this.getAppointments) {
        if (
          /(consulta|retorno)/gi.test(appointment.obj['medical_consultation_type']) &&
          appointment.obj.status.indexOf('CANCELADO') === -1
        ) {
          const types = [
            {
              value: 'DRCONECTA',
              label: 'Dr. Conecta',
              attribute: 'type',
              count: 0,
              subGroup: '1'
            },
            {
              value: 'PARTICULAR',
              label: 'Particular',
              attribute: 'type',
              count: 0,
              subGroup: '1'
            },
            {
              value: 'PARTICULAR_TELEMEDICINA',
              label: 'Teleconsulta',
              attribute: 'type',
              count: 0,
              subGroup: '1'
            },
            {
              value: 'CONVENIO',
              label: 'Convênio',
              attribute: 'type',
              count: 0,
              subGroup: '1'
            },
            {
              value: ['ABERTO', 'EM ANDAMENTO', 'NÃO COMPARECEU', 'REALIZADO', 'REAGENDADO'],
              label: 'Confirmada',
              attribute: 'status',
              count: 0,
              subGroup: '2'
            },
            {
              value: 'AGUARDANDO CONFIRMAÇÃO PELO PACIENTE',
              label: 'Não confirmada',
              attribute: 'status',
              count: 0,
              subGroup: '2'
            }
          ]
          for (let type of types) {
            const matches = typeof type.value === 'string'
              ? type.value === appointment.obj[type.attribute]
              : type.value.includes(appointment.obj[type.attribute])

            if (matches) {
              if (!this.categories[0].data[type.subGroup]) {
                this.categories[0].data[type.subGroup] = {}
                type.count = 1
                this.categories[0].data[type.subGroup][type.label] = type
              } else if (!this.categories[0].data[type.subGroup][type.label]) {
                type.count = 1
                this.categories[0].data[type.subGroup][type.label] = type
              } else {
                this.categories[0].data[type.subGroup][type.label].count += 1
                const pluralLabel = /conecta/gi.test(type.label)
                  ? type.label
                  : type.label.endsWith('r')
                    ? `${type.label}es`
                    : `${type.label}s`

                this.categories[0].data[type.subGroup][type.label].label = pluralLabel
              }
            }
          }
          this.categories[0].total += 1
        }

        if (/(exame|procedimento)/gi.test(appointment.obj['medical_consultation_type'])) {
          if (this.categories[1].data.length === 0) {
            this.categories[1].data.push({
              label: appointment.obj.doctor_office_medical_service.medical_service.name,
              count: 1,
              id: appointment.obj.doctor_office_medical_service.medical_service.id
            })
          } else {
            for (let data of this.categories[1].data) {
              if (data.id === appointment.obj.doctor_office_medical_service.medical_service.id) {
                data.count = data.count + 1
              } else {
                this.categories[1].data.push({
                  label: appointment.obj.doctor_office_medical_service.medical_service.name,
                  count: 1,
                  id: appointment.obj.doctor_office_medical_service.medical_service.id
                })
              }
            }
          }
          this.categories[1].total += 1
        }
        if (appointment.obj.status && /cancelado/gi.test(appointment.obj.status)) {
          // if (this.categories[2].total < 5) {
          this.categories[2].data.push({
            label: appointment.obj.user.name || appointment.obj.patient.name || appointment.obj.special_patient.name,
            count: this.$moment(appointment.obj.appointment_start).format('DD/MM, HH') + 'h'
          })
          this.categories[2].total += 1
          // }
        }
      }
    }
  }
}
</script>
